// Per-service stroke icons (24×24 viewBox). Order matches lib/data/services.ts.
const SERVICE_ICONS = [
  // 01 Influencer Marketing — person + network nodes
  <>
    <circle cx="12" cy="7.5" r="3.2" strokeWidth="1.5" />
    <path
      d="M4.5 21c0-4.14 3.36-7.5 7.5-7.5s7.5 3.36 7.5 7.5"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="4" cy="14.5" r="1.5" strokeWidth="1.2" />
    <circle cx="20" cy="14.5" r="1.5" strokeWidth="1.2" />
    <path
      d="M9 10.5L5.5 13M15 10.5L18.5 13"
      strokeWidth="1"
      strokeLinecap="round"
      strokeOpacity="0.6"
    />
  </>,
  // 02 Campaign Design & Execution — megaphone + broadcast
  <>
    <path
      d="M3 8.5v7L6.5 18l7.5 4V4.5L6.5 8 3 8.5z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17 8a5 5 0 0 1 0 8" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M20.5 5.5a9.5 9.5 0 0 1 0 13"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeOpacity="0.5"
    />
  </>,
  // 03 Measurement & MMM — bar chart + trend line
  <>
    <path d="M3 21h18" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M6 21V15M11 21V9M16 21V13" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M4 14l4-5 4 3.5 5-7.5"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.55"
    />
  </>,
  // 04 Analysis & Compliance — document with check
  <>
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M14 2v6h6" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M9 14l2 2 4-4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </>,
  // 05 Celebrity Ads — star with inner glow circle
  <>
    <path
      d="M12 2l2.7 8.3H23l-7 5.1 2.7 8.3L12 18.4l-6.7 5.3 2.7-8.3-7-5.1h8.3L12 2z"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="2.5" strokeWidth="1" strokeOpacity="0.4" />
  </>,
  // 06 Digital Billboard — monitor + play button
  <>
    <rect x="2" y="3" width="20" height="14" rx="2" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M8 21h8M12 17v4" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 8l5 3.5-5 3.5V8z" strokeWidth="1.2" strokeLinejoin="round" />
  </>,
]

export function ServiceIcon({ idx, size, active }: { idx: number; size: number; active: boolean }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? 'rgba(255,255,255,1)' : 'rgba(11,22,41,1)'}
      aria-hidden
      className="flex-shrink-0 select-none pointer-events-none"
      style={{ opacity: active ? 0.09 : 0.07 }}
    >
      {SERVICE_ICONS[idx]}
    </svg>
  )
}
